<template>
  <div>
    <p>
      <strong>{{$t('contract.sickness.headline') }}</strong>
    </p>
    <p>{{$t('contract.sickness.paragraphs.first') }}</p>
    <ol>
      <li v-show="sickness.reportNow">
        <span class="user-output">{{$t('contract.sickness.report_now.label') }}</span>
      </li>
      <li v-show="sickness.reportThreeDays">
        <span class="user-output">{{$t('contract.sickness.report_three_days.label') }}</span>
        <span>{{$t('contract.sickness.paragraphs.second') }}</span>
      </li>
    </ol>

    <hr />
  </div>
</template>

<script>
export default {
  computed: {
      sickness() {
        return this.$store.state.contract.sickness;
      },
    }
};
</script>